import * as types from '../types';

const INITIAL_STATE = {
    username: '',
    password: '',
    recoveryUsername: '',
    facebookID: '',
    facebookEmail: '',
    facebookFirstName: '',
    facebookLastName: '',
    facebookMobile: '',
    serverToken: ''
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.LOGIN_UPDATE_STATE:
            return { ...state, ...action.payload };
        case types.LOGIN_RESET_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};
